<script>
import t from "@/components/page/HomeView/data/text.json";

export default {
  data() {
    return {
      t,
    };
  },
};
</script>

<template>
  <section class="list-page">
    <div class="content">
      <router-link
        :to="item.link"
        :class="`list-page__item js-scroll scrolled fade-in-bottom delay${
          id + 1
        }`"
        v-for="(item, id) in t.itemPages"
        :key="id"
      >
        <div class="list-page__img">
          <div class="list-page__img-icon app-btn-circle">
            <img
              v-if="item.iconType === 'Статья'"
              class="list-page__img-icon--icon1"
              src="@/assets/icons/ui/t_1.svg"
              alt="icon"
            />
            <img
              v-if="item.iconType === 'видео'"
              class="list-page__img-icon--icon2"
              src="@/assets/icons/ui/t_2.svg"
              alt="icon"
            />
            <img
              v-if="item.iconType === 'Квиз'"
              class="list-page__img-icon--icon3"
              src="@/assets/icons/ui/t_3.svg"
              alt="icon"
            />
            <img
              v-if="item.iconType === 'Материал для пациентов'"
              class="list-page__img-icon--icon4"
              src="@/assets/icons/ui/t_4.svg"
              alt="icon"
            />
          </div>

          <picture>
            <source
              media="(max-width: 600px)"
              :srcset="`${require('@/assets/img/page/HomeView/' +
                item.img +
                '_mob.webp')} 1x, ${require('@/assets/img/page/HomeView/' +
                item.img +
                '_mob@2x.webp')} 2x`"
              type="image/webp"
            />
            <source
              media="(max-width: 525px)"
              :srcset="`${require('@/assets/img/page/HomeView/' +
                item.img +
                '_mob.png')} 1x, ${require('@/assets/img/page/HomeView/' +
                item.img +
                '_mob@2x.png')} 2x`"
              type="image/png"
            />

            <source
              media="(min-width: 526px) and (max-width: 768px)"
              :srcset="`${require('@/assets/img/page/HomeView/' +
                item.img +
                '_tablet.webp')} 1x, ${require('@/assets/img/page/HomeView/' +
                item.img +
                '_tablet@2x.webp')} 2x`"
              type="image/webp"
            />
            <source
              media="(min-width: 526px) and (max-width: 768px)"
              :srcset="`${require('@/assets/img/page/HomeView/' +
                item.img +
                '_tablet.png')} 1x, ${require('@/assets/img/page/HomeView/' +
                item.img +
                '_tablet@2x.png')} 2x`"
              type="image/png"
            />

            <source
              media="(min-width: 769px)"
              :srcset="`${require('@/assets/img/page/HomeView/' +
                item.img +
                '_desk.webp')} 1x, ${require('@/assets/img/page/HomeView/' +
                item.img +
                '_desk@2x.webp')} 2x`"
              type="image/webp"
            />
            <img
              class="list-page__img-main"
              :src="
                require('@/assets/img/page/HomeView/' + item.img + '_desk.png')
              "
              :srcset="`${require('@/assets/img/page/HomeView/' +
                item.img +
                '_desk.png')} 1x, ${require('@/assets/img/page/HomeView/' +
                item.img +
                '_desk@2x.png')} 2x`"
              :alt="`${item.name}`"
            />
          </picture>
        </div>
        <p class="list-page__type" v-html="item.iconType"></p>
        <h2 class="list-page__title" v-html="item.name"></h2>
      </router-link>
    </div>
  </section>
</template>

<style scoped lang="scss">
.list-page {
  padding: 24px 60px 54px 60px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    padding: 24px 20px;
  }

  .content {
    max-width: 1320px;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);

    gap: 40px 24px;

    @media screen and (max-width: 1023px) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);
      gap: 40px 20px;
    }

    @media screen and (max-width: 700px) {
      gap: 24px 8px;
    }
  }

  &__item {
    width: 100%;
    position: relative;
    z-index: 20;

    @media screen and (min-width: 1024px) {
      &:hover {
        cursor: pointer;
        user-select: none;

        .list-page__img-icon {
          &::before {
            background: radial-gradient(
                100% 100% at 50% 0%,
                rgba(255, 255, 255, 1) 0%,
                rgba(255, 255, 255, 0) 100%
              ),
              linear-gradient(0deg, #22b28a 0%, #6fd691 100%);
          }

          &::after {
            background: linear-gradient(0deg, #01cb93 0%, #60fe94 100%);
          }
        }
      }
    }
  }

  &__img {
    position: relative;

    &-icon {
      position: absolute;
      left: 0;
      bottom: 0;

      width: 22.5%;
      height: 29.01%;

      width: calc((60px / 424px) * 100%);
      height: calc((60px / 328.181px) * 100%);

      @media screen and (max-width: 768px) {
        width: calc((60px / 354px) * 100%);
        height: calc((60px / 274px) * 100%);
      }

      @media screen and (max-width: 525px) {
        width: calc((35px / 156px) * 100%);
        height: calc((35px / 121px) * 100%);
      }

      img {
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }

    &-main {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__type {
    color: var(--9CFFAC, #9cffac);

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0.56px;
    text-transform: uppercase;
    margin-bottom: 8px;
    margin-top: 14px;

    @media screen and (max-width: 600px) {
      font-size: 10px;
    }
  }

  &__title {
    color: var(--Text-White, #fff);
    font-family: "MetaPro", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    text-transform: uppercase;

    @media screen and (max-width: 600px) {
      font-size: 16px;
    }
  }
}
</style>
